import { CiCircleCheck } from "react-icons/ci";

interface FormSuccessProps {
  message?: string;
}

export const FormSuccess = ({ message }: FormSuccessProps) => {
  if (!message) return null;

  return (
    <div className="bg-emerald-500/15 p-2 rounded-md flex items-center gap-x1 text-sm text-emerald-500">
      <CiCircleCheck className="h-4 w-4 mr-2" />
      <p>{message}</p>
    </div>
  );
};
